import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['counter', { 'length-warning': _ctx.warning, visible: _ctx.visible }])
    }, _toDisplayString(_ctx.counterText), 3));
}
